// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__cSP-p","text":"styles-m__text__3fYWO","rate-tag":"styles-m__rate-tag__1eDH0","check-price-rate":"styles-m__check-price-rate__3NtG0"};